import { withEditorContext } from 'wix-rich-content-editor-common/libs/EditorEventsContext';

import { AboutEditModal } from './AboutEditModal';

export default withEditorContext(AboutEditModal);
